module.exports = __webpack_public_path__ + "media/images/lb/991-8959fc699b3d86ed2f0229b9be8c02fa.svg";